
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import { apiFetch } from './utils/ApiFetch';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const encodedUsername = btoa(username) + "~" + Date.now();
            const encodedPassword = btoa(password) + "~" + Date.now();
            const response = await apiFetch(`${config.API_BASE_URL}/authenticate`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json','X-username':username },
                body: JSON.stringify({ username: encodedUsername, password: encodedPassword }),
            });
            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('mr_token', data.data.mr_token);
                sessionStorage.setItem('username', username);
                sessionStorage.setItem('user_type', data.data.user_type);
                localStorage.setItem('isLoggedIn', 'true');
				navigate(`/home?r=${Math.floor(Math.random() * 1000000)}`);

            } else {
                alert('Invalid credentials');
            }
        } catch (error) {
            alert('Error connecting to server');
        }
    };

    return (
        <div className="container min-vh-100 d-flex justify-content-center align-items-center">
            <div className="card shadow-lg border-0 w-100 mx-auto" style={{ maxWidth: '400px', borderRadius: '16px' }}>
                <div className="card-body p-4">
                    <div className="text-center mb-4">
					<img src="/images/mrlogoBO.png" alt="Logo" style={{ width: '180px', marginBottom: '10px' }} />


					<h3
					  className="mb-2 fw-bold text-info"
					  style={{
					    textShadow: '0 2px 8px rgba(0,0,0,0.12)',
					    letterSpacing: '0.12em'
					  }}
					>
					  Back Office Login
					</h3>


                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Username:</label>
                            <input
                                type="text"
                                className="form-control"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                autoComplete="username"
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Password:</label>
                            <input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                autoComplete="current-password"
                            />
                        </div>


						<button
						  type="submit"
						  className="btn btn-info text-light rounded-pill mx-auto d-block"
						  style={{
						    width: '160px',
						    boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
						  }}
						>
						  <i className="fa fa-sign-in text-light" />&nbsp; Login
						</button>


                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
